import { observable, action, makeObservable } from 'mobx';
import { localStorageHandler } from 'core/services';
import { translate } from 'core/utils';

class ErrorStore {
	@observable errors = null;

	constructor(rootStore) {
        makeObservable(this);
        this.rootStore = rootStore;

        this.initialize();
    }

	@action setErrors = errors => {
		this.errors = getFormattedError(errors);
	};

	initialize() {
		const self = this;

		window.addEventListener('unhandledrejection', event => {
			event.stopPropagation();
			event.preventDefault();

			const { reason } = event;

			if (typeof reason === 'object') {
				if (reason.request !== undefined && reason.statusCode !== undefined) {
					// A resource the caller may not have is answered with 404 so it cannot be told apart
					// from a mistyped id; both land on the not found page rather than the error dump.
					if (reason.statusCode === 404) {
						if (self.rootStore.routerStore.routerState.routeName !== 'master.not-found') {
							self.rootStore.routerStore.goTo('master.not-found');
						}
						return true;
					}

					let errors = {
						Reason: getApiErrorReason(reason.statusCode),
					};
					if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
						Object.assign(errors, { APIRequest: reason.request });
					}
					self.setErrors(errors);

					if (self.rootStore.routerStore.routerState.routeName !== 'master.error') {
						const authTokenKey = localStorageHandler.get('react-baasic-token');
						if (!authTokenKey) {
							self.rootStore.routerStore.goTo('master.app.membership.login');
						} else {
							self.rootStore.routerStore.goTo('master.error');
						}
					}
				}
			}

			return true;
		});
	}
}

function getFormattedError(error) {
	const errorType = typeof error;
	if (errorType === 'string') {
		return {
			Reason: error,
		};
	} else if (errorType === 'object') {
		return error;
	}

	return {
		Reason: translate('INTERNALERROR'),
	};
}

function getApiErrorReason(statusCode) {
	switch (statusCode) {
		case 0:
			return 'Endpoint not found';
		case 500:
			return 'Server error';
	}

	return translate('INTERNALERROR');
}

export default ErrorStore;
